import Config from "../models/config";
import { ISprint } from "../models/sprint";
import { ISprintTask, SprintTask } from "../models/sprintReport";
import { ITask } from "../models/task";
import { ITaskScores, TaskScore } from "../models/taskScore";
import { IUserInfo } from "../models/userInfo";

// quyền hiển thị thông tin điểm
export const roleForPoint = (user?: IUserInfo) => {
    return user?._id?.toString() != '6157c696e40d4cf6e89ff757';
};

// quyền xem thông tin điểm
export const roleViewForPoint = (user?: IUserInfo) => {
    const role = user?.role;
    return role === Config.USER_ROLE_STAFF
        || role === Config.USER_ROLE_INTERN
        || role === Config.USER_ROLE_MID_LEADER;
};

export const calculateTaskScoreFromSprintReport = (sprintTasks: ISprintTask[]): ITaskScores => {
    let pointDone = 0;
    let expTask = 0;
    let totalPoint = 0;
    sprintTasks?.forEach((s) => {
        if (s.state == 1 || s.state == 2 || s.checkPoint) {
            pointDone += s.point;
            expTask += s.point * s.coef;
        }
        // if (s.state !== -1) {
        //vi task o TO DO van duoc luu point
        totalPoint += s.point;
        // }
    });
    let tasksDone = sprintTasks?.filter((s) => s.state == 1 || s.state == 2 || s.checkPoint)?.length ?? 0;
    let totalTaskInSprint = sprintTasks?.filter((s) => s.state != -1)?.length ?? 0;
    let taskDoneInDeadline = sprintTasks?.filter((s) => s.state == 2)?.length ?? 0;
    let totalTasks = sprintTasks?.length;
    let bug = sprintTasks?.filter((s) => s.taskType === "Bug")?.length ?? 0;
    let { taskDonePercentage, pointDonePercentage, taskDoneInDeadlinePercentage, doneRate } = calculatePercentage(
        totalTaskInSprint,
        tasksDone,
        pointDone,
        taskDoneInDeadline
    );
    return new TaskScore({
        tasksDone: tasksDone,
        pointDone: pointDone,
        totalTaskInSprint: totalTaskInSprint,
        taskDoneInDeadline: taskDoneInDeadline,
        expTask: expTask,
        totalTasks: totalTasks,
        taskDonePercentage: taskDonePercentage,
        pointDonePercentage: pointDonePercentage,
        taskDoneInDeadlinePercentage: taskDoneInDeadlinePercentage,
        doneRate: doneRate,
        bug: bug,
        totalPoint: totalPoint,
    });
};

export const calculatePercentage = (
    totalTaskInSprint: number,
    tasksDone: number,
    pointDone: number,
    taskDoneInDeadline: number
) => {
    let taskDonePercentage = totalTaskInSprint == 0 ? 0 : Math.round((tasksDone / totalTaskInSprint) * 100);
    let pointDonePercentage = Math.round((pointDone / Config.DEFAULT_POINT) * 100);
    let taskDoneInDeadlinePercentage = totalTaskInSprint == 0 ? 0 : Math.round((taskDoneInDeadline / totalTaskInSprint) * 100);
    return {
        taskDonePercentage: taskDonePercentage,
        pointDonePercentage: pointDonePercentage,
        taskDoneInDeadlinePercentage: taskDoneInDeadlinePercentage,
        doneRate: Math.round(
            ((pointDone / Config.DEFAULT_POINT) * 100 +
                (totalTaskInSprint == 0 ? 0 : (taskDoneInDeadline / totalTaskInSprint) * 100)) /
                2
        ),
    };
};
/**
 * Cẩn thận logic hàm này/ (mục đích hàm này để check một task có được tính điểm vào một sprint hay không)
 * ban đầu coi các task không ở todo và có ngày khởi tạo nằm trong phạm vi thời gian của sprint đang xét (như thế thì các task TODO ở sprint trước khi sang sprint sau sẽ bị check fail)
 * [Bổ sung check finishedDate cho các task được create ở sprint trước, nếu finishedDate nằm ngoài sprint thì là nó không được tính, nằm trong thì vẫn tính]
 * @param task task được xét
 * @param sprint sprint được xét
 * @returns
 */
export const checkTasksInSprint = (task: ITask, sprint: ISprint) => {
    // trường hợp ở sprint để TO DO rồi sang sprint sau mới kéo thì hàm này check sai
    let check = false;
    // trước tiên cần check task phải nằm ngoài TO DO
    if (task.statusId !== Config.COLUMN_STATUS.TO_DO.mongoId) {
        // trường hợp task được tạo trong sprint đang xét => true
        if (
            new Date(task.createdTime).getTime() >= new Date(sprint.startDate).getTime() &&
            new Date(task.createdTime).getTime() <= new Date(sprint.endDate).getTime()
        ) {
            check = true;
        }
        // trường hợp task được tạo ngoài sprint (xử lý cho trường hợp task được tạo ở sprint trước nhưng để ở TO DO sang sprint này mới kéo để làm)
        else if (
            new Date(task.createdTime).getTime() < //tạo ở sprint trước
                new Date(sprint.startDate).getTime() &&
            (task.finishedDate == -1 || //chưa được đánh dấu là finish
                new Date(task.finishedDate).getTime() >= // đánh dấu là finish sau khi sprint đang xét bắt đầu (có thể finish trong sprint đang xét hoặc sau đó (thì tại sprint đang xét vẫn sẽ được tín))
                    new Date(task.createdTime).getTime())
        ) {
            check = true;
        }
    }
    return check;
};
export const convertTaskToReport = (task: any, currentSprint: ISprint): ISprintTask => {
    let taskState: -1 | 0 | 1 | 2 = 0;
    let point = 0;
    task.statusId = task?.statusId ?? task.status;
    if (!checkTasksInSprint(task, currentSprint)) {
        //task khong duoc tinh vao sprint thi point = 0 ? nam o TO DO?
        taskState = -1;
        if (task.status === Config.COLUMN_STATUS.TO_DO.mongoId) point = task.point ?? 0;
    } else {
        //check task done or not
        if (
            task.statusId === Config.COLUMN_STATUS.DONE.mongoId ||
            task.statusId === Config.COLUMN_STATUS.PROD_VALIDATION.mongoId
        ) {
            //done
            let timeDone = new Date(task.finishedDate);
            if (timeDone && !!task.deadline) {
                if (timeDone.getTime() <= new Date(task.deadline).getTime()) {
                    //done in deadline
                    taskState = 2;
                } else taskState = 1;
            } else taskState = 1;
        } else taskState = 0; //chua done
        point = task.point ?? 0;
    }
    return new SprintTask({
        taskID: task._id,
        taskName: "",
        point: point,
        coef: task.coef,
        state: taskState,
        status: task.status,
        taskType: task.type,
        checkPoint: task.checkPoint, // nếu có checkpoint thì tính điểm
    });
};
